module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BI-9dc07b98a6cb49a75be8529b34cb404d.png";